!function(n){var i=null;-1!==n.indexOf("Win")&&(i="win"),-1!==n.indexOf("Mac")&&(i="mac"),-1!==n.indexOf("X11")&&(i="unix"),-1!==n.indexOf("Linux")&&(i="linux"),window.osName=i}(navigator.appVersion);



//////////////////
// WEBPACK FOOTER
// ./src/javascript/detect-os.js
// module id = 4
// module chunks = 0